import {
  addCareplanToBasket,
  ERROR_ADD_CAREPLAN_TO_BASKET,
  ERROR_ADD_CAREPLAN_TO_BASKET_INVALID_RESPONSE
} from './addCareplanToBasket';
import { ERROR_BASKET_ID } from './getBasket';

export const createFailedResponse = (title = null, message = null) => {
  const failedResponse = {
    status: 'failed',
    error: {
      title: 'Unknown error',
      message: 'Addding careplan to basket failed unexpectedly.'
    }
  };
  if (title && message) {
    return {
      ...failedResponse,
      error: { title, message }
    };
  }

  return failedResponse;
};

export const createSuccessResponse = (addToBasketresponse) => {
  const { basketId } = addToBasketresponse;
  return {
    status: 'success',
    basketId: basketId
  };
};

export const addCareplanToBasketSilently = async (storeUrl, productId, carePlanId, callback) => {
  let addToBasketresponse;
  try {
    addToBasketresponse = await addCareplanToBasket(storeUrl, productId, carePlanId);
  } catch (e) {
    const { message } = e;
    switch (message) {
      case ERROR_BASKET_ID:
        callback(createFailedResponse(
          'Basket error',
          'Could not get current basket ID'
        ));
        break;
      case ERROR_ADD_CAREPLAN_TO_BASKET:
        callback(createFailedResponse(
          'Network error',
          'Could not add careplan to the basket. API endpoint unreacheble.'
        ));
        break;
      case ERROR_ADD_CAREPLAN_TO_BASKET_INVALID_RESPONSE:
        callback(createFailedResponse(
          'Unknown error',
          'Could not add careplan to the basket. API endpoint responded with an error.'
        ));
        break;
      default:
        callback(createFailedResponse());
    }
    return;
  }
  callback(createSuccessResponse(addToBasketresponse));
};
